
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Basit bir kaynak yapısı kullanıyoruz
const resources = {
  tr: {
    translation: {
      // Temel çeviriler
      welcome: "Hoş geldiniz",
      home: "Ana Sayfa",
      gallery: "Galeri",
      about: "Hakkımızda",
      contact: "İletişim"
    }
  },
  en: {
    translation: {
      welcome: "Welcome",
      home: "Home",
      gallery: "Gallery", 
      about: "About",
      contact: "Contact"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'tr',
    fallbackLng: 'tr',
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
